module.exports = __webpack_public_path__ + "media/images/illust/illust-single-946c33b9d006205d657f19c1e6cceb5f.svg";